import {autorun, makeObservable, observable, set} from "mobx";
import {observer} from "mobx-react";
import {Component} from "preact";
import codeAnimation from "../img/code-animation.gif";
import {connection, cubeModel, fancyAlert} from "../model";
import {resources} from "../resources";
import {Button} from "./controls/Button";
import {Dialog, DialogContent, DialogTitle} from "./controls/Dialog";
import {KeyPad} from "./controls/KeyPad";
import {TextInput} from "./controls/TextInput";
import style from "./EnterLocationCodeDialog.module.css";

interface EnterLocationCodeDialogProps {
	open: boolean;
	onClose: () => void;
}

export const EnterLocationCodeDialog = observer(
	class EnterLocationCodeDialog extends Component<EnterLocationCodeDialogProps> {
		code = "";
		pending = false;
		codeLength = 3;

		constructor(props: EnterLocationCodeDialogProps) {
			super(props);
			makeObservable(this, {
				code: observable,
				pending: observable,
				codeLength: observable,
			});
		}

		async componentWillMount() {
			const {length} = await cubeModel.getLocationCodeShape();
			this.codeLength = length;
			autorun(async () => {
				if (this.code.length >= this.codeLength) {
					try {
						this.pending = true;
						await cubeModel.addCubeByCode(this.code);
					}
					catch (error) {
						fancyAlert(resources.strings.InvalidLocationCodeMessage);
					}
					finally {
						this.props.onClose();
						set(this, {
							code: "",
							pending: false,
						});
					}
				}
			});
		}

		render() {
			const {open, onClose} = this.props;
			const {code, pending} = this;

			return (
				<Dialog open={open} onBackdropClick={onClose}>
					<DialogContent>
						<DialogTitle>{resources.strings.EnterLocationCode}</DialogTitle>

						<div class={style.locationCodeMessage}>
							{resources.strings.LocationCodeMessage}
						</div>

						<div class={style.codeAnimationContainer}>
							<img src={codeAnimation} class={style.codeAnimation} />
						</div>

						<TextInput
							pending={pending}
							disabled={pending}
							readOnly
							value={code}
							onChange={this.handleCodeChange}
							onBackspace={this.handleCodeBackspace}
							type={"text"}
						/>

						<KeyPad disabled={pending} onType={this.handleKeypadType} />

						<Button disabled={pending} onClick={onClose}>{resources.strings.Cancel}</Button>
					</DialogContent>
				</Dialog>
			);
		}

		private handleCodeChange = (newCode: string) => {
			this.code = newCode;
		};

		private handleCodeBackspace = () => {
			this.code = this.code.substring(0, this.code.length - 1);
		};

		private handleKeypadType = (digit: string) => {
			this.code += digit;
		};
	},
);
